import apiFetch from '../apiFetch'

export default function (idRuta, token) {
  return apiFetch({endPoint: `Ruta/cambioEstadoRuta`, method: 'POST', body: {idRuta}, token: token})
}
